/**
 * Created by masoud on 05/05/17.
 */
module.exports = [
    {
        tab: {
            icon: 'icon-star',
            text: 'امنیت‌ و‌آسایش'
        },
        content: {
            image: -796,
            header: 'امنیت در اولویت است',
            subHeader: 'امنیت کاربران اولویت اصلی اسنپ است. به همین منظور تلاش می‌کنیم قابلیت‌هایی در جهت امنیت و آسایش بیشتر سفرهای خود به وجود آوریم. قابلیت‌هایی مانند:',
            text: '<ul><li>' + 'تایید صلاحیت کاربران راننده توسط ناجا' + '</li>' +
            '<li>' + 'ثبت اطلاعات کاربر راننده در تاکسی اینترنتی' + '</li>' +
            '<li>' + 'بررسی خودرو کاربر راننده' + '</li>' +
            '<li>' + 'عکس کاربر راننده' + '</li>' +
            '<li>' + 'امکان به اشتراک گذاشتن اطلاعات و نقشه مسیر با آشنایان' + '</li>' +
            '<li>' + 'پنهان‌سازی شماره تلفن کاربران راننده و مسافر در حین تماس' + '</li>'
        }
    },
    {
        tab: {
            icon: 'icon-clock',
            text: 'ویژگی‌‌ها و قابلیت‌ها'
        },
        content: {
            image: -996,
            header: 'با تاکسی اینترنتی اسنپ، هوشمند سفر کنید',
            subHeader: 'ویژگی‌های اسنپ همه آن چیزی است که یک شهروند هوشمند به آن نیاز دارد. قابلیت‌هایی مانند:',
            text: '<li>' + 'صرفه‌جویی در هزینه و زمان' + '</li>' +
            '<li>' + 'حق انتخاب در نحوه پرداخت هزینه سفر (آنلاین یا نقدی)' + '</li>' +
            '<li>' + 'امکان انجام سفر رفت‌وبرگشت یا دو مقصده' + '</li>' +
            '<li>' + 'امکان انتخاب مدت زمان توقف در مسیر' + '</li>' +
            '<li>' + 'پشتیبانی ۲۴ساعته با تاکسی اینترنتی' + '</li>' +
            '<li>' + 'امکان ذخیره آدرس‌های منتخب در اپلیکیشن' + '</li>' +
            '<li>' + 'امکان انجام سفر رایگان، با معرفی اسنپ به دوستان' + '</li>'
        }
    },
    {
        tab: {
            icon: 'icon-credit-card',
            text: 'خدمات متنوع'
        },
        content: {
            image: -200,
            header: 'چند سرویس در یک اپلیکیشن',
            subHeader: 'کاربران با نصب اپلیکیشن اسنپ می‌توانند علاوه بر استفاده از خدمات تاکسی اینترنتی از سرویس‌های مختلف سوپراپلیکیشن اسنپ هم استفاده کنند. سرویس‌هایی مانند:',
            text: '<li>' + '<strong>اسنپ اکو:</strong> سفری مقرون‌به‌صرفه و با کیفیت' + '</li>' +
            '<li>' + '<strong>اسنپ‌رُز:</strong> سفر بانوان و خانواده‌ها، با هم‌راهان خانم' + '</li>' +
            '<li>' + '<strong>اسنپ‌باکس:</strong> حمل بسته و مرسولات با موتورسیکلت' + '</li>' +
            '<li>' + '<strong>اسنپ‌‌‌‌‌وانت:</strong> جابه‌جایی بارهای سنگین' + '</li>' +
            '<li>' + '<strong>اسنپ‌بایک:</strong> جابه‌جایی مسافران با موتورسیکلت' + '</li>'+
            '<li>' + '<strong>اسنپ‌فود:</strong> سفارش غذا' + '</li>' +
            '<li>' + '<strong>اسنپ‌مارکت:</strong> خرید از سوپرمارکت‌ها و شعبه‌های هایپراستار' + '</li>' +
            '<li>' + '<strong>اسنپ‌تریپ:</strong> رزرو هتل‌های داخلی و خارجی و خرید بلیت هواپیما و اتوبوس' + '</li>' 

        }
    },
    {
        tab: {
            icon: 'icon-cloud',
            text: 'راهکارهای سازمانی'
        },
        content: {
            image: -596,
            header: 'نیاز یک سازمان هوشمند',
            subHeader: 'اسنپ راهکارهایی برای هوشمندسازی حمل‌ونقل کارکنان سازمان‌ها و شرکت‌ها دارد. خدماتی مانند:',
            text: '<strong>پنل سازمانی:</strong> با ثبت‌نام در پنل سازمانی، از طریق یک صفحه وب می‌توان از تمام سرویس‌های تاکسی اینترنتی اسنپ استفاده کرد. استفاده همزمان از همه سرویس‌ها، مدیریت بهتر سفرها، شفاف‌سازی هزینه‌های حمل‌ونقل سازمانی و گزارش‌گیری قابل اعتماد از قابلیت‌های این پنل است.' + '\n' +
            '<strong>کد سازمانی:</strong> در این حالت، یک کد سازمانی مخصوص برای سازمان و تمام اعضای مجموعه ایجاد می‌شود. به این ترتیب ریز گزارش‌ سفرهای کارمندان به صورت هفتگی با تاکسی اینترنتی اسنپ برای مسئول سازمان ارسال می‌شود.'
        }
    }
];





// WEBPACK FOOTER //
// ./src/js/config/SnappFeatures.js